import VueRouter from "vue-router";
import Vue from "vue";
import config from "./config";
import store from "../store";

// 1. 安装 VueRouter 插件
Vue.use(VueRouter);

// 2. 创建路由实例
const router = new VueRouter(config);

/**
 * 路由全局前置守卫
 * @description 在路由跳转前进行权限验证和导航控制
 * 主要功能:
 * 1. 验证用户登录状态(token)
 * 2. 获取用户信息和权限
 * 3. 验证用户是否有访问目标页面的权限
 * 4. 设置当前激活的导航菜单项
 */
router.beforeEach(async (to, from, next) => {
  try {
    // 2. 登录页和错误页直接放行,无需权限验证(优先判断,避免循环)
    if (to.name === "Login" || to.name === "Error" || to.name === "ListenMusic") {
      return next();
    }

    // 获取本地存储的 token
    const token = localStorage.getItem("token");

    // 1. 未登录时,除登录页外,其他页面都跳转到登录页
    if (!token) {
      return next({ name: "Login" });
    }

    // 3. 已登录状态,获取用户信息和权限
    // 注: store.dispatch 是 Vuex 官方推荐的调用 action 的方式
    // 适用于在非组件环境(如路由守卫)中调用
    const result_userInfo = await store.dispatch("getUserInfoAction");

    // 4. 用户信息获取失败或 token 失效,401，403 都跳转登录页
    if (result_userInfo.code !== 200) {
      console.warn("用户信息获取失败:", result_userInfo.message);
      localStorage.removeItem("token"); // 清除失效的 token
      return next({ name: "Login" });
      // if (result_userInfo.code === 401) {
      //   return next({ name: "Login" });
      // } else {
      //   return next({ name: "Error" });
      // }
    }

    // 5. 根据目标路由路径,查找并激活对应的导航菜单项
    await store.dispatch("findActive", {
      filterNavList: store.state.filterNavList,
      path: to.path,
    });

    // 开发环境下打印当前激活的导航ID,便于调试
    if (process.env.NODE_ENV === "development") {
      console.log("当前激活导航:", store.state.active);
    }

    // 6. 欢迎页面无需权限验证,直接放行
    if (to.name === "Welcome") {
      return next();
    }

    // 7. 验证用户是否有访问目标页面的权限
    // active 为空表示用户无权访问该页面
    if (!store.state.active) {
      console.warn(`无权限访问页面: ${to.path}`);
      return next({ name: "Error", replace: true });
    }

    // 8. 权限验证通过,放行
    next();
  } catch (error) {
    // 捕获异步操作中的错误,防止路由卡死
    console.error("路由守卫执行错误:", error);
    // 发生错误时跳转到错误页
    next({ name: "Error" });
  }
});

export default router;
